<script setup>
import { computed } from 'vue'
import { componentSizeMap, useFormSize } from 'element-plus'

const $props = defineProps({
  id: {
    type: [Number, String],
    required: true
  },
  name: {
    type: String,
    default: ''
  },
  avatar: {
    type: String,
    default: ''
  },
  type: {
    type: String,
    default: 'info'
  },
  closable: {
    type: Boolean,
    default: false
  }
})
const $emits = defineEmits(['close'])

const formSize = useFormSize()
const getComponentSize = computed(() => {
  return componentSizeMap[formSize.value || 'default'] - 12
})
const onClose = () => {
  $emits('close', $props.id)
}
const displayName = computed(() => $props.name || '未知用户')
const getFirstChar = (str) => {
  if (!str) return '?'
  return String(str).charAt(0)
}
</script>
<template>
  <el-tag round :closable="$props.closable" :type="type" effect="light" @close="onClose">
    <div class="user-tag-inner">
      <el-avatar :size="getComponentSize" :src="avatar">
        {{ getFirstChar(displayName) }}
      </el-avatar>
      <span class="user-tag-name">{{ displayName }}</span>
    </div>
  </el-tag>
</template>

<style scoped lang="scss">
:deep(.el-tag__content) {
  flex: 1;
  min-width: 0;
}

.user-tag-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 100%;
  min-width: 0;
}

.user-tag-name {
  display: inline-block;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
}
</style>
